module.exports = __webpack_public_path__ + "static/media/funitures1.f2c77da0.svg";